export function axisGridThemeInputs(theme) {
    return {
        cacheKey: {
            gridVisibleHorizontal: theme.gridVisible?.horizontal,
            gridVisibleVertical: theme.gridVisible?.vertical,
            gridColorHorizontal: theme.gridColorHorizontal,
            gridColorVertical: theme.gridColorVertical,
        },
        options: {
            gridVisible: theme.gridVisible,
            gridColorHorizontal: theme.gridColorHorizontal,
            gridColorVertical: theme.gridColorVertical,
        },
    };
}
